import moment from "moment";
import dashboard from "../menu-items/dashboard";

//dev api base url
// export const baseURL = "http://13.234.173.125:8081";


//staging api base url
//  export const baseURL =  "https://immunoact.hashstudioz.com";

// uat api base url
export const baseURL = "https://uat.immunoact.hashstudioz.com";


// Patient table data conversion
export const convertSubjectData = (data) => {
  return data?.map((sub) => {
    let transformCode = sub?.subject_code;
    let transformedSubjectInitial = sub?.sub_initials;
    let transformeInvestigator = sub?.investigatorDetails?.name;
    let transformedEditor = sub?.editorDetails?.name;
    return [
      transformCode,
      transformedSubjectInitial,
      transformeInvestigator,
      transformedEditor,
    ];
  });
};

export const checkForSubchild = (firstSegment) => {
  let isChild = null;
  for (let item of dashboard.children) {
    if (item?.subChildren) {
      for (let subItem of item.subChildren) {
        if (subItem.id === firstSegment) {
          isChild = subItem;
          isChild.parent = item.title;
          isChild.parentId = item.id;
          break;
        }
      }
    }
  }
  return isChild;
};

function isDarkColor(color) {
  const r = parseInt(color.substr(1, 2), 16);
  const g = parseInt(color.substr(3, 2), 16);
  const b = parseInt(color.substr(5, 2), 16);
  const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
  return brightness < 128;
}

const usedColors = new Set();

export function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color;

  do {
    color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
  } while (
    isDarkColor(color) ||
    color === "#000000" ||
    color === "#00008B" ||
    usedColors.has(color)
  );

  usedColors.add(color);
  return color;
}
const formatDate = (dateString) => {
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};

export function capitalizeFirstLetter(str) {
  if (!str) return "N/A"; // handle empty or undefined strings
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function capitalizeWords(str) {
  if(!str) return ""
  return str?.toLowerCase()?.split(" ")?.map(word => word?.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const formatDateForApi = (date) => {
  if (!date) return null;

  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;

  const pad = (n) => String(n).padStart(2, '0');

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
         `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

export const formatDateMoment = (date) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export const dateofBirthMoment = (date) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
};
/*
export function formatDateMoment(date) {
  if (!date || !moment(date).isValid()) {
    return "-"; // Return 'N/A' if the date is invalid or missing
  }
  return moment.utc(date).format("DD/MM/YYYY"); // Format the date to 'dd/mm/yyyy'
}*/

// Helper function to get all unique questions
const getAllUniqueQuestions = (data) => {
  const questions = new Set();
  data.forEach((item) => {
    item.appointment.forEach((appointment) => {
      appointment.reports.forEach((report) => {
        questions.add(report.question.trim()); // Add question to the set
      });
    });
  });
  return Array.from(questions); // Convert set back to an array
};

export const getCurrentDateTime = (date ='') => {
  const now = date ? new Date(date): new Date();
  
  // Get day, month, year
  const day = now.getDate();
  const month = now.toLocaleString('default', { month: 'long' });
  const year = now.getFullYear();
  
  // Get time in 12-hour format with AM/PM
  let hours = now.getHours();
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  
  // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // Convert 0 to 12
  
  return `${day} ${month} ${year} at ${hours}:${minutes} ${ampm}`;
};

export const jsonToCsv = (data) => {
  const csvRows = [];

  // Define static headers (excluding the columns to be moved to the end)
  const headers = [
    "S.No.",
    "Patient ID",
    "First Name",
    "Last Name",
    "Patient Status",
    "Status Change",
    "Visit Type",
    "Appointment Title",
  ];

  // Get all unique dynamic headers (questions) from all appointments
  const dynamicHeaders = getAllUniqueQuestions(data);

  // Add the columns to be moved to the end
  const endingHeaders = ["Open Queries", "Pending Approval", "Approved"];

  // Combine headers and push to CSV rows
  csvRows.push(
    [...headers, ...dynamicHeaders, ...endingHeaders]
      .map((header) => `"${header}"`)
      .join(",")
  );

  // Initialize serial number counter
  let serialNumber = 1;

  // Extract rows
  data.forEach((item) => {
    item.appointment.forEach((appointment) => {
      // Static data without the moved columns
      const staticData = [
        serialNumber++,
        item.subject.patient_id || "-",
        item.subject.first_name,
        item.subject.last_name,
        capitalizeFirstLetter(item.subject.life_status),
        formatDateMoment(item.subject.status_change_date),
        appointment.form_title,
        appointment.title,
      ];

      // Dynamic data from reports
      const dynamicData = dynamicHeaders.map((header) => {
        // Find the report with the current question (header)
        const report = appointment.reports.find(
          (r) => r.question.trim() === header
        );
        let answer = report?.answer || ""; // Use empty string if no answer is found

        // Format date answers
        if (typeof answer === "string" && /^\d{4}-\d{2}-\d{2}$/.test(answer)) {
          answer = formatDate(answer); // Assuming you have a formatDate function
        }

        // Handle answers that might be arrays or null
        if (Array.isArray(answer)) {
          return `"${answer.filter(Boolean).join(", ")}"`; // Filter out nulls and join array answers with commas
        } else if (answer === null || answer === "") {
          return ""; // Leave empty for null or empty answers
        } else {
          return `"${answer.replace(/\n/g, " ")}"`; // Replace newlines with spaces
        }
      });

      // Data for the columns moved to the end
      const endingData = [
        appointment.query_raised?.length > 0
          ? `"${appointment.query_raised.join(", ")}"`
          : "N/A", // Join query raised with semicolon
        appointment.pending_users?.length > 0
          ? `"${appointment.pending_users.join(", ")}"`
          : "N/A", // Join pending users with semicolon
        appointment.approved_users?.length > 0
          ? `"${appointment.approved_users.join(", ")}"`
          : "N/A", // Join approved users with semicolon
      ];

      // Combine static, dynamic, and ending data and push to CSV rows
      csvRows.push([...staticData, ...dynamicData, ...endingData].join(","));
    });
  });

  return csvRows.join("\n");
};

export const downloadCsv = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  // Create a link element, set the download attribute, and trigger a click event
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();

  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export function checkValueIsDate(value) {
  const parsedDate = moment(value);
  if (parsedDate.isValid()) {
    return true;
  } else {
    return false;
  }
}

export function convertIntoTimeZone(value) {
  if (!value) return;
  const [day, month, year] = value.split("/").map(Number);
  // Create Date object using the extracted values (note: month is 0-based)
  const date = new Date(year, month - 1, day, 10, 7, 28); // set time to 10:07:28
  return date.toString();
}

export function getValueByPath(obj, path) {
  const parts = path.split('.'); // split by dot
  return parts.reduce((acc, part) => {
    if (acc === undefined || acc === null) return undefined;
        if (typeof acc === "string") {
      try {
        const parsed = JSON.parse(acc);
        acc = parsed;
      } catch {
         // ignore if not a JSON string
      }
    }
    // if part is a number, convert to integer (for arrays)
    if (!isNaN(part)) part = parseInt(part, 10);
    return acc[part];
  }, obj);
}

export function parseDynamicValue(value) {
  if (typeof value !== 'string') return value; // already parsed
  try {
    // Try JSON.parse
    const parsed = JSON.parse(value);
    // If it's still a string (e.g. "\"19:20\""), remove extra quotes
    if (typeof parsed === 'string') {
      return parsed;
    }
    return parsed; // could be array/object/number/etc
  } catch (e) {
    // Not JSON, return as is
    return value;
  }
}

export const filteredFormValues = (transformedFormValues) => {
   return Object.fromEntries(
  Object.entries(transformedFormValues).filter(([, val]) => {
    return !(
      val === "" ||
      val === null);
  })
)
}

function toTitleCase(str) {
    return str
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\w\S*/g, (txt) => 
            txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        ); // Capitalize each word
}


export function combineLabelTitle(label, path) {
  const parts = path.split('.'); // split by dot
  if(parts?.length > 1){
  return toTitleCase(parts?.[0])+' →'+label
  }
  return label
}

export const  firstLetterShouldCapital = (string) => {
     return string?.split(' ').map(n => n[0]).join('').toUpperCase() || ''
}

export const formatPathName = (path) => {
  if(!path) return
  if(path && Array.isArray(path))
    path = path?.[0]?.path
  let parts = path.split("/").filter(Boolean);
  if (parts[0]?.toLowerCase() === "bmr") {
    parts.shift();
  }
let lastPart = parts.pop() || "";
if(!isNaN(lastPart)){
  lastPart = parts?.shift() || ''
}
  if (lastPart.toLowerCase() === "qa") return "Quality Approval";
  if (lastPart.toLowerCase() === "lsm") return "QR Code Generation";
  if (lastPart.toLowerCase() === "qc") return "Quality Control";  
   return lastPart
    .split("-")
    .map(word => {
      if (word.toLowerCase() === "lsm") return "LSM"; // force uppercase
      if (word.toLowerCase() === "bmr") return "BMR"; // force uppercase
      if (word.toLowerCase() === "manufacturer_view") return "Manufacturer View"; // force uppercase
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export const findSlugString = (slug) => {
  const match = slug.match(/(\d+)(.*)/);
  if (!match) return null;

  return match[2]
    .replace(/^-/, "")
    .replace(/^-/, "")

}

export const truncateText = (text, limit = 25) => {
    if (!text) return "-";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
};


 export const getLastIdFromUrl = (url) => {
  const parts = url?.split('/');
  return parts?.[parts?.length - 1];
};

export const cleanPayload = (obj) => {
  return Object.fromEntries(
    // eslint-disable-next-line no-unused-vars
    Object.entries(obj).filter(([__, v]) => 
      v !== null && 
      v !== undefined && 
      v !== "" && 
      !(Array.isArray(v) && v.length === 0)
    )
  );
};

export const getTooltipTextButton = (submitRequest, cycleLengthIssue, isTerminated, noTermination, isInActive, label) => {

  if (submitRequest) {
    return "Change Request already submitted";
  }
  
  if (isTerminated) {
    return "The Cycle is terminated";
  }
  if (isInActive) {
    return "This cycle is In-active";
  }
   if(noTermination){
     return "Change Request should be active when Cycle is terminating";
 }
 if (cycleLengthIssue) {
    return "The active pool cycle count is insufficient";
  }
  return label;
};

export const normalizeEmptyToNull = (item) =>{
     return Object.fromEntries(
        Object.entries(item).map(([key, value]) => [
          key,
          value === "" ? null : value,
        ])
      );
}


export const getNextCycleName = (cyclesData = []) => {
  if (!cyclesData.length) return "Cycle 1";

  const cycleNumbers = cyclesData
    .map(item => {
      const match = item?.cycle?.match(/\d+/);
      return match ? Number(match[0]) : null;
    })
    .filter(num => num !== null);

  const maxCycle = cycleNumbers.length ? Math.max(...cycleNumbers) : 0;

  return `Cycle ${maxCycle + 1}`;
};

export const formattedSampleVal = (field_value) => {
  if (!field_value) return '';

  // Normalize input → array
  const valuesArray = Array.isArray(field_value)
    ? field_value
    : typeof field_value === 'string'
      ? field_value.split(',')
      : [];

  return valuesArray
    .map(item =>
      item
        .trim()
        .split('_')
        .map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(' ')
    )
    .join(', ');
};